export default {
  // INDEX_FLOW_TAGS_INIT(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowTags = payload;
  // },
  // INDEX_FLOW_TYPE(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowType = payload;
  // },
  // INDEX_FILTER_TYPE(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFilterType = payload;
  // },
  // INDEX_EACH_FLOW_ARTICLE_DATA(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowArticle = payload;
  // },
  // INDEX_EACH_FLOW_SCOOP_DATA(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowScoop = payload;
  // },
  // INDEX_EACH_FLOW_RESUME_DATA(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowResume = payload;
  // },
  // INDEX_EACH_FLOW_QA_DATA(st, payload) {
  //   // eslint-disable-next-line no-param-reassign
  //   st.indexFlowQa = payload;
  // },

  INDEX_CHANGE_OVERVIEW_FEATURE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.indexOverviewMode = payload;
  },

  POST_BASIC_OPTION(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.postBasicOption = payload;
  },
  POST_CORE_OPTION(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.postCoreOption = payload;
  },
  POST_CHECK_PASS(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.postCheckPass = payload;
  },
  POST_VALUE(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.postValue = payload;
  },
  POST_ERROR_TEXT(st, payload) {
    // eslint-disable-next-line no-param-reassign
    st.postErrorText = payload;
  },
};
